import React from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';

import Profile from './Profile';
import { profileAnalytics } from './types/profileAnalytics';

const { settingsProfile } = profileAnalytics;

export const profileRoute = (
  <Route
    path="profile"
    element={
      <PageRoute pageInfo={settingsProfile}>
        <Profile />
      </PageRoute>
    }
  />
);
